import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documentarchives',
  templateUrl: './documentarchives.component.html',
  styleUrls: ['./documentarchives.component.css']
})
export class DocumentarchivesComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  } 
}